import { z } from "zod";
import { searchParam } from "@amber/ui";

const AUDIT_RANGES = ["all", "today", "7d", "30d"] as const;
export type AuditRange = (typeof AUDIT_RANGES)[number];

export const auditSearchSchema = z.object({
  actor: searchParam(z.string()),
  action: searchParam(z.string()),
  subject: searchParam(z.string()),
  range: searchParam(z.enum(AUDIT_RANGES)),
  q: searchParam(z.string()),
  entry: searchParam(z.string()),
});
export type AuditSearch = z.infer<typeof auditSearchSchema>;
